import cloneDeep from 'lodash/cloneDeep';
import * as Types from './actionTypes';

const initialState = {
  summary: {},
  quotes: [],
  paid: {},
};

const reducer = function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.INIT: {
      const { summary, quotes } = payload;

      const newState = cloneDeep(state);
      newState.summary = summary;
      newState.quotes = quotes || [];
      return newState;
    }
    case Types.RESET: {
      return initialState;
    }
    case Types.MARK_AS_PAID: {
      const newState = cloneDeep(state);
      newState.paid = { ...action.payload };
      return newState;
    }

    default:
      return state;
  }
};

export default reducer;
